import React from 'react';

export const MatchContext = React.createContext({
    createMatches: (attendees) => {},
    filters: [],
    setFilters: (filters) =>  [],
    warnings: '',
    setWarnings: (e) => {},
    getData: (e) => {}
});